import {ContextMenuActionCallback, ContextMenuCreateCallback} from "./context-menu-types";
import {ContextMenuItem} from "./context-menu-item";
import {ContextMenuSeparator} from "./context-menu-separator";

export class ContextMenu {

  private createCallbacks: ContextMenuCreateCallback[] = [];

  constructor() {}

  addContextMenuSeparator(): ContextMenu {
    this.createCallbacks.push(() => Promise.resolve([this.createContextMenuSeparator()]));
    return this;
  }

  addContextMenuItem(label: string, actionCallback: ContextMenuActionCallback, labelSuffix: string, prefixIcon: string): ContextMenu {
    this.createCallbacks.push(() => Promise.resolve([this.createContextMenuItem(label, actionCallback, labelSuffix, prefixIcon)]));
    return this;
  }

  addContextMenuItems(items: ContextMenuItem[]): ContextMenu {
    this.createCallbacks.push(() => Promise.resolve(items));
    return this;
  }

  registerCreateCallback(cb: ContextMenuCreateCallback): ContextMenu {
    this.createCallbacks.push(cb);
    return this;
  }

  async getMenuItems(): Promise<ContextMenuItem[]> {
    const menus = await Promise.all(this.createCallbacks.map((cb) => cb(this)));
    const flattenedMenus: ContextMenuItem[] = menus.flat();
    // Remove repeated separators
    return flattenedMenus.filter((m, idx, arr) => {
      return idx === 0 ? m : (m.isSeparator && arr[idx - 1].isSeparator ? null : m);
    }).filter((m) => m!== null);
  }

  createContextMenuSeparator() {
    return new ContextMenuSeparator();
  }

  createContextMenuItem(label: string, actionCallback: ContextMenuActionCallback, labelSuffix?: string, prefixIcon?: string) {
    return new ContextMenuItem(label, actionCallback, labelSuffix, prefixIcon);
  }
}
